<template>
  <div class="background_news">
    <div class="news_index_text">
      <p style="font-size: 24px;margin-bottom: 1vh" class="animate__fadeInUp animate__animated">我们的优势</p>
      <p style="font-size: 36px;margin: 0" class="animate__fadeInUp animate__animated animate__delay-1s">感念际遇 不生苦毒</p>
      <p style="font-size: 36px; margin-bottom: 3vh;" class="animate__fadeInUp animate__animated animate__delay-1s">尊重对手 战胜自己</p>
      <p style="font-size: 14px" class="animate__fadeInUp animate__animated animate__delay-2s">十余年来，海纳亚洲主要聚焦投资科技、传媒、消费品、现代服务、医疗、环保等领域。</p>
      <div style="padding-top: 2vh" class="animate__fadeInUp animate__animated animate__delay-3s">
        <a-button v-on:click="next_page" type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: "News_index",
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 90 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>

<style scoped>
.news_index_text {
  padding-top: 34vh;
  text-align: left;
  margin-left: 12vw;
}

.background_news {
  background-image: url("../../../assets/background/index_news.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  margin: 0;
}

</style>